<template>
  <button @click="botClick()" class="bot-slide" :class="botActive?'slide-active':''">
    <div class="bot-slider"></div>
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    botsNames: {
      type: Array,
      requiere: true
    }
  },
  data() {
    return {
      botActive: false,
    };
  },
  methods: {
    botClick() {
      this.botActive = !this.botActive
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";
.bot-slide,
.slide-active {
  width: 250px;
  padding: 5px 45px;
  height: 50px;
  font-size: 1.3rem;
  line-height: 1.2rem;
  text-align: right;
  border-radius: 25px;
  -moz-box-shadow: inset 0 0 10px #000000;
  -webkit-box-shadow: inset 0 0 10px #000000;
  box-shadow: inset 0 0 10px #000000;
  position: relative;
  color: #444;
  margin: 7px auto;
  background-color: white;
  &:hover {
    background-color: lighten($secondary-red, 40);
  }
  .bot-slider {
    background-color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    -moz-box-shadow: 0 0 10px #777;
    -webkit-box-shadow: 0 0 10px #777;
    box-shadow: 0 0 10px #777;
    position: absolute;
    left: 6px;
    top: 10px;
    @include transit(all, 0.5s);
  }
}
.slide-active {
  background-color: $secondary-red;
  color: white;
  text-align: left;
  .bot-slider {
    left: 215px;
  }
}
</style>



// WEBPACK FOOTER //
// BotSlide.vue?00bca91c